import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import Header from './Header';
import { updatePos, getPos } from '../actions';
import { Bars } from  'react-loader-spinner'
import { withRouter } from './withRouter';

let self = null;

class PointOfSaleEdit extends Component {
    constructor(props){
        super(props);

        this.state= {
            id: '',
            name: '',
            personInCharge: '',
            email: '',
            phone: '',
            direction: '',
            location: '',
            open: false,
            msg: ''
        };

        self = this;
    }

    componentDidMount = () => {
        const {params } = this.props;
        this.props.getPos(params.id, () => {
            self.setState({
                id: params.id,
                name: self.props.pos.name,
                personInCharge: self.props.pos.personInCharge,
                email: self.props.pos.email,
                phone: self.props.pos.phone,
                direction: self.props.pos.direction,
                location: self.props.pos.location,
            });
        });
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleCancel = () => {
        this.props.navigate('/pos');
    }

    handleSave = () => {
        if(this.state.name !== ''){
            const {id, name, personInCharge, email, phone, direction, location} = this.state;
            this.props.updatePos({id, name, personInCharge, email, phone, direction, location}, function() {
                self.setState({
                    msg: self.props.posUpdatedMsg
                });
                setTimeout(function(){
                    self.props.navigate('/pos');
                },1500);
            });
        }else{
            this.setState({open: true});
        }
    }

    handleAddressChange = (e) => {
        this.setState({
            direction: e.target.value
        });
    }

    handleEmailChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    handleLocationChange = (e) => {
        this.setState({
            location: e.target.value
        });
    }

    handlePersonInChargeChange = (e) => {
        this.setState({
            personInCharge: e.target.value
        });
    }

    handlePhoneChange = (e) => {
        this.setState({
            phone: e.target.value
        });
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    }

    renderLoader = () => {
        if(this.props.updatingPos){
            return <Bars color="#17a2b8" height={30} width={30} />;
        }
    }
    renderPosMsg = () => {
        return (
            <span className="posMsg">{this.state.msg}</span>
        );
    }

    renderPOSForm = () => {
        const { open } = this.state;
        return (
            <div className="componentContainer">
                <Header />
                <Modal
                    open={open}
                    onClose={this.onCloseModal}
                    showCloseIcon={false}
                >
                    <div className="modalContentContainer">
                        <span className="modalTitle">Debe ingresar al menos un nombre para crear un nuevo punto de venta</span>
                        <div className="modalBtnsContainer">
                            <button
                                className="btn btn-primary"
                                onClick={() => this.setState({open: false})}
                            >
                                Aceptar
                            </button>
                        </div>
                    </div>
                </Modal>
                <div className="sectionContainer">
                    <div className="headerSection">
                        <div className="headerContent">
                            <div className="headerSectionTitle">Nuevo Punto de Venta</div>
                        </div>
                    </div>
                    <div className="usersColumns">
                        <div className="posForm">
                        <div className="posFormGroup">
                                <span>Nombre</span>
                                <input
                                    value={this.state.name}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => this.handleNameChange(e)}
                                />
                            </div>
                            <div className="posFormGroup">
                                <span>Persona responsable</span>
                                <input
                                    value={this.state.personInCharge}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => this.handlePersonInChargeChange(e)}
                                />
                            </div>
                            <div className="posFormGroup">
                                <span>Email</span>
                                <input
                                    value={this.state.email}
                                    type="email"
                                    className="form-control"
                                    onChange={(e) => this.handleEmailChange(e)}
                                />
                            </div>
                            <div className="posFormGroup">
                                <span>Teléfono</span>
                                <input
                                    value={this.state.phone}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => this.handlePhoneChange(e)}
                                />
                            </div>
                            <div className="posFormGroup">
                                <span>Dirección</span>
                                <input
                                    value={this.state.direction}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => this.handleAddressChange(e)}
                                />
                            </div>
                            <div className="posFormGroup">
                                <span>Localidad</span>
                                <input
                                    value={this.state.location}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => this.handleLocationChange(e)}
                                />
                            </div>
                            <div className="posFormGoup btnGroup">
                                <button
                                    className="btn btn-success"
                                    onClick={this.handleSave}
                                >
                                    Guardar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={this.handleCancel}
                                >
                                    Cancelar
                                </button>
                            </div>
                            <div className="posFormGroup loaderHolder">
                                {this.renderLoader()}
                            </div>
                            <div className="posFormGroup posMsgHolder">
                                {this.renderPosMsg()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderComponent = () => {
        return this.props.auth ? (
            this.renderPOSForm()
        ) : (
           <Navigate
                to={{
                    pathname: '/login',
                    state: { from: this.props.location }
                }}
            />
        );
    }

    render() {
        return this.renderComponent();
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth.authenticated,
        updatingPos: state.posData.updatingPos,
        posUpdatedMsg: state.posData.posUpdatedMsg,
        pos: state.posData.uniquePos
    };
};

export default connect(mapStateToProps, { updatePos, getPos })(withRouter(PointOfSaleEdit));